(function() {
  const swiperInstances = new Map();

  function initSlider(slider) {
    const config = JSON.parse(slider.dataset.swiperConfig);
    const swiperEl = slider.querySelector('.swiper');
    
    if (!swiperEl) return;

    // Destroy existing instance if any
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }

    const swiperOptions = {
      slidesPerView: config.slidesPerViewAuto ? 'auto' : config.slidesPerViewMobile,
      spaceBetween: config.slideGap,
      loop: config.loop,
      pagination: {
        el: slider.querySelector('.ctr-testimonials__pagination'),
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      navigation: {
        nextEl: slider.querySelector('.ctr-testimonials__nav-next'),
        prevEl: slider.querySelector('.ctr-testimonials__nav-prev')
      },
      breakpoints: {
        768: {
          slidesPerView: config.slidesPerViewAuto ? 'auto' : (config.slidesPerView),
          spaceBetween: config.slideGap
        }
      }
    };

    if (config.autoplay) {
      swiperOptions.autoplay = {
        delay: config.autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    const swiper = new Swiper(swiperEl, swiperOptions);
    swiperInstances.set(slider, swiper);
    
    return swiper;
  }

  function initAllSliders() {
    document.querySelectorAll('.ctr-testimonials__slider[data-swiper-config]').forEach(function(slider) {
      initSlider(slider);
    });
  }

  function destroySlider(slider) {
    if (swiperInstances.has(slider)) {
      swiperInstances.get(slider).destroy(true, true);
      swiperInstances.delete(slider);
    }
  }

  function getSectionSlider(sectionId) {
    return document.querySelector(`.ctr-testimonials--${sectionId} .ctr-testimonials__slider[data-swiper-config]`);
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', initAllSliders);

  // Shopify Theme Editor Events
  document.addEventListener('shopify:section:load', function(event) {
    const slider = event.target.querySelector('.ctr-testimonials__slider[data-swiper-config]');
    if (slider) {
      initSlider(slider);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const slider = event.target.querySelector('.ctr-testimonials__slider[data-swiper-config]');
    if (slider) {
      destroySlider(slider);
    }
  });

  document.addEventListener('shopify:section:select', function(event) {
    const slider = event.target.querySelector('.ctr-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', function(event) {
    const slider = event.target.querySelector('.ctr-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const config = JSON.parse(slider.dataset.swiperConfig);
      if (config.autoplay && swiper.autoplay) {
        swiper.autoplay.start();
      }
    }
  });

  document.addEventListener('shopify:block:select', function(event) {
    const slider = event.target.closest('.ctr-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const slide = event.target.closest('.swiper-slide');
      
      if (slide) {
        const slideIndex = Array.from(slider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).indexOf(slide);
        if (slideIndex !== -1) {
          swiper.slideToLoop(slideIndex);
        }
      }
      
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    const slider = event.target.closest('.ctr-testimonials__slider[data-swiper-config]');
    if (slider && swiperInstances.has(slider)) {
      const swiper = swiperInstances.get(slider);
      const config = JSON.parse(slider.dataset.swiperConfig);
      if (config.autoplay && swiper.autoplay) {
        swiper.autoplay.start();
      }
    }
  });
})();
